import { Component } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ScrollService } from '../../../services/scroll-service';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, NgOptimizedImage, UpperCasePipe } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { SearchStoreService } from '../../../../modules/frontpage/stores/search-store.service';
import { RouterEventsService } from '../../../services/router-events.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    UpperCasePipe,
    FlexLayoutModule,
    TranslateModule,
    NgOptimizedImage,
  ],
})
export class HeaderComponent {
  constructor(private scrollService: ScrollService, public router: Router, private searchStore: SearchStoreService) {}
  version = environment.appVersion;

  onLogoClick() {
    this.scrollService.markLogoClick();
    SearchStoreService.isCurrentShowsChecked = true;
    this.router.navigate(['/']);
  }
}
